// extracted by mini-css-extract-plugin
module.exports = {"item":"footer_item__CVCPV","contact_info":"footer_contact_info__CTK_E"};